import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import { fetchJitsiToken } from "../services/meeting.services";

export function useFetchJitsiToken(roomName: string) {
    return useQuery<
        IApiResponse<{ token: string }>,
        AxiosError<IApiResponse<{ token: string }>>
    >({
        queryKey: ["jitsi-token", roomName],
        queryFn: () => fetchJitsiToken(roomName),
        cacheTime: 6 * 60 * 60 * 1000, // 6hrs
        staleTime: 6 * 60 * 60 * 1000, // 6hrs
    });
}
